export const colors: string[] = ["#0066b2", "#002D62"];
